/**
 * Centralized localStorage keys for the customer portal
 * All localStorage access should use these constants to prevent typos and enable easy refactoring
 */

export const STORAGE_KEYS = {
  // Authentication state
  AUTH_STAGE: 'auth_stage',
  ACCOUNT_ID: 'account_id',
  ACCESS_CODE: 'access_code',
  CUSTOMER_NAME: 'customer_name',
  USER_ID: 'user_id',
  USER_EMAIL: 'user_email',
  DEMO_MODE: 'demo_mode',

  // Fake 2FA (temporary until real 2FA)
  FAKE_2FA_CODE: 'fake_2fa_code',
  FAKE_2FA_CODE_EXPIRY: 'fake_2fa_code_expiry',
  FAKE_2FA_METHOD: 'fake_2fa_method',

  // Magic Auth / Verification
  WORKOS_JWT: 'workos_jwt',
  MAGIC_AUTH_EMAIL: 'magic_auth_email',
  MAGIC_AUTH_PHONE: 'magic_auth_phone',
  VERIFICATION_METHOD: 'verification_method',
  FROM_VERIFICATION_GATE: 'from_verification_gate',

  // Authentication mode (persisted to survive page reload)
  AUTH_MODE: 'auth_mode',

  // Cookie consent (strictly-necessary storage; shared by Hub + Portal)
  COOKIE_CONSENT: 'cookie_consent',
  CONSENT_SUBJECT_ID: 'consent_subject_id',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
